import { Menu, X, LogOut } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

interface HeaderProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;  // desktop expand/collapse
  openMobile: () => void;     // mobile drawer open
}

const Header: React.FC<HeaderProps> = ({ isSidebarOpen, toggleSidebar, openMobile }) => {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <header className="flex items-center justify-between bg-white border-b px-3 md:px-4 py-2.5">
      {/* Mobile hamburger */}
      <button
        onClick={openMobile}
        className="p-2 rounded hover:bg-gray-100 text-gray-700 md:hidden"
        aria-label="Menüyü Aç"
      >
        <Menu size={22} />
      </button>

      {/* Desktop sidebar toggle */}
      <button
        onClick={toggleSidebar}
        className="p-2 rounded hover:bg-gray-100 text-gray-700 hidden md:inline-flex"
        aria-label="Yan menüyü genişlet/daralt"
        title={isSidebarOpen ? 'Daralt' : 'Genişlet'}
      >
        {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      <h1 className="text-base md:text-lg font-semibold text-gray-800 mx-auto md:mx-0">
        Admin Panel
      </h1>

      <button
        onClick={handleLogout}
        className="inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
      >
        <LogOut size={16} />
        Çıkış Yap
      </button>
    </header>
  );
};

export default Header;
